const colorsLandingPage: {[key: string]: number[]} = {
  white: [255, 255, 255],
  'light-blue': [217, 246, 255],
  'light-green': [249, 255, 238],
};

export function initGradientBackground({
  colors = colorsLandingPage,
}: {
  colors?: {[key: string]: number[]};
} = {}) {
  // Make current RGB color closer to target RGB color in step of 2
  function tweenColor(current: number[], target: number[]) {
    const result = [...current];
    let done = true;
    for (let i = 0; i < 3; i += 1) {
      if (Math.abs(current[i] - target[i]) <= 1) {
        continue;
      }

      if (current[i] > target[i]) {
        result[i] -= 2;
        done = false;
      } else if (current[i] < target[i]) {
        result[i] += 2;
        done = false;
      }
    }
    return {result, done};
  }

  if (!('IntersectionObserver' in window)) {
    return;
  }

  let backgroundStartColor = colors.white;
  let backgroundEndColor = colors.white;
  let backgroundStartColorDone = false;
  let backgroundEndColorDone = false;
  let targetStartColor = colors.white;
  let targetEndColor = colors.white;

  const container = document.querySelector('html');
  const sections = document.querySelectorAll(
    '[data-background-gradient-start][data-background-gradient-end]',
  );
  let animationReference: number | null = null;

  const updateBackgroundGradient = () => {
    const {result: startColor, done: startDone} = tweenColor(
      backgroundStartColor,
      targetStartColor,
    );
    backgroundStartColor = startColor;
    backgroundStartColorDone = startDone;
    const {result: endColor, done: endDone} = tweenColor(
      backgroundEndColor,
      targetEndColor,
    );
    backgroundEndColor = endColor;
    backgroundEndColorDone = endDone;

    container!.style.setProperty(
      '--background-start-color',
      `rgb(${backgroundStartColor.join()})`,
    );
    container!.style.setProperty(
      '--background-end-color',
      `rgb(${backgroundEndColor.join()})`,
    );

    if (!backgroundStartColorDone || !backgroundEndColorDone) {
      animationReference = requestAnimationFrame(updateBackgroundGradient);
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        const element = entry.target;

        if (!(element instanceof HTMLElement)) {
          return;
        }

        if (element.dataset.hasIntersectedOnce === 'false') {
          // TODO: Consider adding Tealium tracking here for when the user scrolls to each section
          element.dataset.hasIntersectedOnce = 'true';
        }

        targetStartColor =
          colors[element.dataset.backgroundGradientStart || 'white'];
        targetEndColor =
          colors[element.dataset.backgroundGradientEnd || 'white'];
        if (animationReference) {
          cancelAnimationFrame(animationReference);
        }
        updateBackgroundGradient();
      });
    },
    {
      threshold: 0.2,
    },
  );

  sections.forEach((element) => {
    observer.observe(element);
  });

  updateBackgroundGradient();
}
